import { defineComponent as B, useSlots as C, computed as w, ref as O, watchEffect as V, createElementBlock as s, openBlock as a, normalizeClass as _, createVNode as o, Transition as b, withCtx as g, withDirectives as x, withModifiers as $, vShow as k, createElementVNode as p, createCommentVNode as c, renderSlot as i, unref as u } from "vue";
import z from "./useMediaQuery.js";
import N from "./Backdrop.js";
import j from "./Divider.js";
import { _ as A } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const D = {
  key: 0,
  class: "tw-px-3 tw-pt-6"
}, M = {
  key: 1,
  class: "tw-px-3 tw-pt-6"
}, P = {
  key: 2,
  class: "tw-pt-6"
}, I = {
  role: "menubar",
  "aria-orientation": "vertical"
}, L = /* @__PURE__ */ B({
  __name: "AppSidebar",
  props: {
    isOpen: { type: Boolean, default: !1 }
  },
  emits: ["dismiss", "update:is-open"],
  setup(y, { emit: S }) {
    const v = y, r = C(), m = S, l = z("screen and (min-width: 1321px)"), e = w(() => v.isOpen && !l.value), n = O({ height: "", overflow: "" }), f = w(() => v.isOpen || l.value);
    function E() {
      m("dismiss"), m("update:is-open", !1);
    }
    function d() {
      return document.scrollingElement || document.body;
    }
    return V(() => {
      l.value || (e.value && Object.assign(n.value, {
        overflow: d().style.overflow,
        height: d().style.height
      }), Object.assign(d().style, {
        overflow: e.value ? "hidden" : n.value.overflow,
        // Prevents page from scrolling when AppSidebar is open
        height: e.value ? "100%" : n.value.height
        // Ensures the backdrop covers the entire page when AppSidebar is open
      }));
    }), (t, h) => (a(), s("div", {
      id: "stash-app-sidebar",
      class: _(["stash-app-sidebar tw-relative", {
        "stash-app-sidebar--is-open": f.value,
        "tw-z-modal": e.value,
        "tw-z-[301]": !e.value
      }]),
      "data-test": "stash-app-sidebar"
    }, [
      o(b, { name: "backdrop" }, {
        default: g(() => [
          x(o(N, {
            class: "stash-app-sidebar__backdrop",
            onClick: $(E, ["stop"])
          }, null, 512), [
            [k, e.value]
          ])
        ]),
        _: 1
      }),
      o(b, { name: "aside" }, {
        default: g(() => [
          x(p("aside", {
            class: _(["stash-app-sidebar__aside tw-fixed tw-flex tw-h-screen tw-flex-col tw-bg-purple-500", { "tw-shadow-3xl": e.value }]),
            "data-test": "stash-app-sidebar__aside"
          }, [
            o(j, { class: "stash-app-sidebar__divider" }),
            u(r)["app-context"] ? (a(), s("div", D, [
              i(t.$slots, "app-context", {}, void 0, !0)
            ])) : c("", !0),
            u(r)["company-context"] ? (a(), s("div", M, [
              i(t.$slots, "company-context", {}, void 0, !0)
            ])) : c("", !0),
            u(r).navigation ? (a(), s("nav", P, [
              p("ul", I, [
                i(t.$slots, "navigation", {}, void 0, !0)
              ])
            ])) : c("", !0),
            h[0] || (h[0] = p("div", { class: "tw-flex-1" }, null, -1)),
            i(t.$slots, "footer", {}, void 0, !0)
          ], 2), [
            [k, f.value]
          ])
        ]),
        _: 3
      })
    ], 2));
  }
}), H = /* @__PURE__ */ A(L, [["__scopeId", "data-v-334e749f"]]);
export {
  H as default
};
//# sourceMappingURL=AppSidebar.js.map
